import { fetchQuery } from 'react-relay';
import get from 'lodash.get';
import { getBuyerId } from 'dibs-cookie-jar';

import { launchTradeGeneralOnboarding } from './launchTradeGeneralOnboarding';
import { tradeGeneralOnboardingQuery } from './tradeGeneralOnboardingQuery';
import { hasSeenTradeGeneralOnboarding, isMobile, isUserTypeTrade } from './helpers';

export const tradeGeneralOnboardingRule = ({ relayEnvironment }) => {
    const userId = getBuyerId(document.cookie);

    if (!userId || !isUserTypeTrade() || isMobile() || hasSeenTradeGeneralOnboarding()) {
        return Promise.resolve(false);
    }

    return fetchQuery(relayEnvironment, tradeGeneralOnboardingQuery, { userId }).then(response => {
        const isNewTradeUser =
            get(response, 'viewer.user.verifiedTradeSubStatus') === 'VERIFIED_IN_LAST_30_DAYS';
        return isNewTradeUser;
    });
};

export const tradeGeneralOnboardingConfig = {
    name: 'tradeGlobalOnboarding',
    rule: tradeGeneralOnboardingRule,
    action: launchTradeGeneralOnboarding,
    priority: 450,
};
